import { render } from "./CathayFlexFilm.vue?vue&type=template&id=c098f976&scoped=true"
import script from "./CathayFlexFilm.vue?vue&type=script&lang=js"
export * from "./CathayFlexFilm.vue?vue&type=script&lang=js"

import "./CathayFlexFilm.vue?vue&type=style&index=0&id=c098f976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c098f976"]])

export default __exports__